import { DateTime } from 'luxon';

import ReportProgress from '@/common/models/ReportProgress';
import i18n from '@/vueI18n';

export default class DeliveryForecastProgress extends ReportProgress {
  private static CSV = 'csv';

  constructor(
    public id = -1,
    public organizationId,
    public lineItemId,
    public amendISBAData,
    public createdOnUtc,
    public executionStartedTimeUtc,
    public executionFinishedTimeUtc,
    public fileFormat,
    public statusCode,
    public statusMessage,
    public progress,
    public reportUrl,
  ) {
    super();
  }

  get isCsv() {
    return this.fileFormat.toLowerCase() === DeliveryForecastProgress.CSV;
  }

  get errorMessage() {
    const errorCode = this.statusMessage.match(/\d+/)[0];
    return i18n.global.t(`errors.isba.${errorCode}`);
  }

  static fromApi(apiObject) {
    let statusMessage = '';
    try {
      statusMessage = apiObject.status_message !== null ? JSON.parse(apiObject.status_message) : null;
    } catch (e) {
      statusMessage = apiObject.status_message;
    }
    return new DeliveryForecastProgress(
      apiObject.deliveryforecastexecution_id,
      apiObject.organization_id,
      apiObject.lineitem_id,
      apiObject.amend_isba_data,
      apiObject.created_on_utc != null ? DateTime.fromISO(apiObject.created_on_utc, { zone: 'utc' }) : null,
      apiObject.execution_started_time_utc != null
        ? DateTime.fromISO(apiObject.execution_started_time_utc, { zone: 'utc' })
        : null,
      apiObject.execution_finished_time_utc != null
        ? DateTime.fromISO(apiObject.execution_finished_time_utc, { zone: 'utc' })
        : null,
      apiObject.file_format,
      apiObject.status_code,
      statusMessage,
      apiObject.progress,
      apiObject.report_url,
    );
  }

  static fromObject(obj) {
    return new DeliveryForecastProgress(
      obj.id,
      obj.organizationId,
      obj.lineItemId,
      obj.amendISBAData,
      obj.createdOnUtc,
      obj.executionStartedTimeUtc,
      obj.executionFinishedTimeUtc,
      obj.fileFormat,
      obj.statusCode,
      obj.statusMessage,
      obj.progress,
      obj.reportUrl,
    );
  }

  toApi() {
    return {
      deliveryforecastexecution_id: this.id >= 0 ? this.id : undefined,
      organization_id: this.organizationId,
      lineitem_id: this.lineItemId,
      amend_isba_data: this.amendISBAData,
      created_on_utc: this.createdOnUtc,
      execution_started_time_utc: this.executionStartedTimeUtc,
      execution_finished_time_utc: this.executionFinishedTimeUtc,
      file_format: this.fileFormat,
      progress: this.progress,
      status_code: this.statusCode,
      status_message: this.statusMessage,
      report_url: this.reportUrl,
    };
  }
}
